import { ListItem, ListSelect } from 'components/ListSelect/ListSelect'
import { Selection } from '@react-types/shared'
import { VoiceData } from 'hooks/useBrandVoices'
import { BrandVoice } from 'almanac-ui/icons'
import { MAX_INITIAL_PILLS } from 'components/DocRightRail/screens/AIAssistant/VoicesAndTonesSelect'

interface Props {
  onChange: (voice?: number) => void
  selectedVoice?: number
  showAll?: boolean
  voices: VoiceData[]
}

export const VoiceSelect = ({ onChange, selectedVoice, voices, showAll }: Props) => {
  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    const [voice] = selection
    onChange(voice ? Number(voice) : undefined)
  }

  const selectedKeys = selectedVoice ? [selectedVoice.toString()] : []

  return (
    <ListSelect selectedKeys={selectedKeys} selectionMode="single" onSelectionChange={handleChange}>
      {voices.slice(0, showAll ? voices.length : MAX_INITIAL_PILLS).map((v) => {
        return (
          <ListItem key={v.id} icon={v.voice_params.emoji ? <span>{v.voice_params.emoji}</span> : <BrandVoice />}>
            {v.voice_params.name}
          </ListItem>
        )
      })}
    </ListSelect>
  )
}
